module.exports = __webpack_public_path__ + "static/media/d14.2eb117fc.jpg";